// extracted by mini-css-extract-plugin
export var errorIcon = "_mc-1";
export var nameLogo = "_mc-0";